import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { formatDate } from '../../utils/dateUtils';
import LazyImage from '../shared/LazyImage';

interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  cover_image: string;
  read_time: number;
  published_at: string;
  category: string;
}

interface BlogCardProps {
  post: BlogPost;
}

export default function BlogCard({ post }: BlogCardProps) {
  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      <Link to={`/blog/${post.slug}`} className="block">
        <LazyImage
          src={post.cover_image}
          alt={post.title}
          aspectRatio="16/9"
          className="w-full h-48"
        />
      </Link>
      <div className="p-6">
        <div className="flex items-center text-sm text-gray-500 mb-3">
          <span className="flex items-center">
            <Calendar className="h-4 w-4 mr-1" />
            {formatDate(post.published_at)}
          </span>
          <span className="mx-2">•</span>
          <span className="flex items-center">
            <Clock className="h-4 w-4 mr-1" />
            {post.read_time} min read
          </span>
        </div>
        
        <Link to={`/blog/${post.slug}`}>
          <h2 className="text-xl font-semibold text-gray-900 mb-2 hover:text-blue-600 transition-colors">
            {post.title}
          </h2>
        </Link>
        
        <p className="text-gray-600 mb-4 line-clamp-2">
          {post.excerpt}
        </p>
        
        <div className="flex items-center justify-between">
          <span className="text-sm text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
            {post.category}
          </span>
          <Link
            to={`/blog/${post.slug}`}
            className="inline-flex items-center text-blue-600 hover:text-blue-700"
          >
            Read More
            <ArrowRight className="h-4 w-4 ml-1" />
          </Link>
        </div>
      </div>
    </article>
  );
}